var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbilityGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 3H7.25C7.65625 3 8 2.65625 8 2.25C8 1.84375 7.65625 1.5 7.25 1.5H4.75C4.34375 1.5 4 1.84375 4 2.25C4 2.65625 4.34375 3 4.75 3ZM4.75 4.5C3.59375 4.5 2.625 3.625 2.5 2.5H2C1.71875 2.5 1.5 2.71875 1.5 3V14C1.5 14.2812 1.71875 14.5 2 14.5H10C10.2812 14.5 10.5 14.2812 10.5 14V3C10.5 2.71875 10.2812 2.5 10 2.5H9.5C9.375 3.625 8.40625 4.5 7.25 4.5H4.75ZM7.25 0C8.03125 0 8.71875 0.40625 9.125 1H10C11.0938 1 12 1.90625 12 3V14C12 15.0938 11.0938 16 10 16H2C0.90625 16 0 15.0938 0 14V3C0 1.90625 0.90625 1 2 1H2.875C3.28125 0.40625 3.96875 0 4.75 0H7.25ZM2.5 8C2.5 7.4375 2.9375 7 3.5 7C4.0625 7 4.5 7.4375 4.5 8C4.5 8.5625 4.0625 9 3.5 9C2.9375 9 2.5 8.5625 2.5 8ZM5.5 8C5.5 7.59375 5.84375 7.25 6.25 7.25H8.75C9.15625 7.25 9.5 7.59375 9.5 8C9.5 8.40625 9.15625 8.75 8.75 8.75H6.25C5.84375 8.75 5.5 8.40625 5.5 8ZM5.5 11C5.5 10.5938 5.84375 10.25 6.25 10.25H8.75C9.15625 10.25 9.5 10.5938 9.5 11C9.5 11.4062 9.15625 11.75 8.75 11.75H6.25C5.84375 11.75 5.5 11.4062 5.5 11ZM3.5 10C4.0625 10 4.5 10.4375 4.5 11C4.5 11.5625 4.0625 12 3.5 12C2.9375 12 2.5 11.5625 2.5 11C2.5 10.4375 2.9375 10 3.5 10Z",
    fill: "#404F69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbilityGroup);
export default __webpack_public_path__ + "static/media/AbilityGroup.e834950136b98583a0fc0250c704b69d.svg";
export { ForwardRef as ReactComponent };